import React, { useContext } from 'react';

import LoadingPage from '../../../components/LoadingPage';

import AnnouncementContext from './AnnouncementContext';
import AnnouncementContextProvider from './AnnouncementContextProvider';

const withAnnouncementContextProvider = (Component) => (props) => (
  <AnnouncementContextProvider>
    <Component {...props} />
  </AnnouncementContextProvider>
);

const withAnnouncementContextReady = (Component) => (props) => {
  const { isReady } = useContext(AnnouncementContext);
  return isReady ? <Component {...props} /> : <LoadingPage />;
};

export {
  withAnnouncementContextProvider,
  withAnnouncementContextReady,
};
